import { Sidebar } from '@ionq/legacy-ui';
import { OrganizationSwitcherMenu } from './OrganizationSwitcherMenu';
import { useSession } from './SessionProvider';

// The org context row (sidebar-07's team switcher slot): the current org,
// led by its tile, as one button opening the switcher menu. Pinned to the
// rail's brand band (over the top bar while collapsed); mounted only with
// a membership to switch to (useHasSwitchTarget) — with a single org the
// band shows the full wordmark.
export function OrgContextRow() {
    const { currentOrganization } = useSession();
    const name = currentOrganization.name || currentOrganization.id;
    return (
        <Sidebar.ContextRow
            name={name}
            avatar={{ logoUrl: currentOrganization.logoUrl }}
        >
            <OrganizationSwitcherMenu trigger={<Sidebar.ContextTrigger />} />
        </Sidebar.ContextRow>
    );
}
